import { render, staticRenderFns } from "./bgimage.vue?vue&type=template&id=385b9286&scoped=true"
import script from "./bgimage.vue?vue&type=script&lang=js"
export * from "./bgimage.vue?vue&type=script&lang=js"
import style0 from "./bgimage.vue?vue&type=style&index=0&id=385b9286&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385b9286",
  null
  
)

export default component.exports